import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.5_next@14.2.35_@babel+core@7.29.7_@opentelemetry+api@1.9.1_react-dom@18._2d6023593b8b36bea51efa78f4b94b17/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.5_next@14.2.35_@babel+core@7.29.7_@opentelemetry+api@1.9.1_react-dom@18._2d6023593b8b36bea51efa78f4b94b17/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.5_next@14.2.35_@babel+core@7.29.7_@opentelemetry+api@1.9.1_react-dom@18._2d6023593b8b36bea51efa78f4b94b17/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Container/Container.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/Breadcrumbs/Breadcrumbs.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/About/Intro.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/About/Features.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/About/Conclusion.module.scss");
